import React, { useCallback, useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import Slider from "@bappweb/slider"
import Amount from "@smpu-web/nested/form/amount"
import CalcutationAmount from "@bappweb/amount"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import { numeric, RegexpTypes, required, dateFormat, minLength } from "@bappweb/utils"
import { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useGetProductInfoMutation } from "src/projects/ticarikredi/api/services"
import { getDayMonthYearFromStr, addThousandSeparator } from "@smpu-web/utils/utils"
import "../assets/style.scss"
import { useAppDispatch, useAppSelector } from "../../../config/hook"
import { calculateMonthlyPayment } from "@smpu-web/utils/calculateinterest"
import Block from "@bappweb/block"
import { setCalcDetails } from "src/projects/ticarikredi/state/calcdetails"
import Grid from "@bappweb/grid"
import Col from "@bappweb/col"
import Row from "@bappweb/row"

const getCid = () => {
  let search = window.location.search;
  let params = new URLSearchParams(search);

  return params.get('cid') ?? "";
}

function CalculateForm() {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const [getCaptcha] = useGetCaptchaMutation();
  const [getTokenByTckn1] = useGetTokenByTckn1Mutation();
  const [refreshCaptcha] = useRefreshCaptchaMutation();
  const [apply] = useApplyMutation()
  const [getProductInfoService, { isLoading }] = useGetProductInfoMutation()

  const [aylikOdeme, setAylikOdeme] = useState(0)
  const [totalPaymentAmt, setTotalPaymentAmt] = useState(0)
  const [faizOrani, setFaizOrani] = useState(0)
  const [yearlyInterestRate, setYearlyInterestRate] = useState("")
  const [isCalledProductService, setIsCalledProductService] = useState(false)
  const [identityNumber, setIdentityNumber] = useState<string>('')
  const [token, setToken] = useState<string>('')
  const [amount, setAmount] = useState(0)
  const [vade, setVade] = useState(0)
  const [productDetail, setProductDetail] = useState({})
  const [showCalcDetails, setShowCalcDetails] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  const [hasAmountError, setHasAmountError] = useState<boolean>(false)
  const [hasVadeError, setHasVadeError] = useState<boolean>(false)
  const [isFetching, setIsFetching] = useState(false)
  const [captchaValues, setCaptchaValues] = useState({
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })
  const [details, setDetails] = useState({
    showSlider: false,
    amountChangedByUser: false,
    vadeChangedByUser: false
  })
  const [productMinsMaxs, setProductMinsMaxs] = useState({
    minVade: 0,
    maxVade: 0,
    minAmount: 0,
    maxAmount: 0
  })

  const showCalcDetailsSelector = useAppSelector((state) => state.calcDetails.response?.showCalcDetails)
  const minVade = useAppSelector((state) => state.calcDetails.response?.minVade)
  const maxVade = useAppSelector((state) => state.calcDetails.response?.maxVade)
  const minAmount = useAppSelector((state) => state.calcDetails.response?.minAmount)
  const maxAmount = useAppSelector((state) => state.calcDetails.response?.maxAmount)

  useEffect(() => {
    if (minVade && maxVade && minAmount && maxAmount){
      const getQuerystringValue = () => {
        let values = {
          amount: maxAmount, loanTerm: maxVade
        }
        const queryParams = new URLSearchParams(window.location.search)
        if (queryParams) {
          const tutar = queryParams.get("tutar")
          const vade = queryParams.get("vade")
          if (tutar) {
            values.amount = parseInt(tutar)
          }
          if (vade) {
            values.loanTerm = parseInt(vade)
          }
        }
        setAmount(values.amount ?? 0)
        setVade(values.loanTerm ?? 0)
      }
      getQuerystringValue()
  
      setProductMinsMaxs({
        minVade: minVade ?? 0,
        maxVade: maxVade ?? 0,
        minAmount: minAmount ?? 0,
        maxAmount: maxAmount ?? 0
      })
    }
  },[minVade, maxVade, minAmount, maxAmount])

  useEffect(() => {
    if (captchaValues.captchaData === "" && token !== "") {
      setIsFetching(true)
      getCaptcha({
        tckn: identityNumber,
        TokenSessionId: token
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setError('')
            setCaptchaValues({
              ...captchaValues,
              showCaptcha: true,
              captchaData: payload.captchaData,
              captchaValidate: true
            })
          }
          else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => { setIsFetching(false) })
    }
  }, [captchaValues, getCaptcha, identityNumber, token])

  useEffect(() => {
    const cleanupIdentifier = setTimeout(() => {
      if (!isCalledProductService) {
        getProductInfo()
      }
    }, 500)

    return () => {
      clearTimeout(cleanupIdentifier)
    }
  }, [isCalledProductService])

  useEffect(() => {
    if (amount || vade || Object.keys(productDetail).length !== 0) {
      calculatePayment()
    }
  }, [amount, vade, productDetail, showCalcDetails])

  const calculatePayment = useCallback(() => {
    let result = {
      aylikOdeme: 0,
      faizOrani: 0,
      yearlyInterestRate: 0,
      totalPaymentAmt: 0
    }

    if (Object.keys(productDetail).length !== 0) {
      result = calculateMonthlyPayment(amount, vade, productDetail, true)
    }

    if (result) {
      setAylikOdeme(isNaN(result.aylikOdeme) ? 0 : result.aylikOdeme)
      setTotalPaymentAmt(isNaN(result.totalPaymentAmt) ? 0 : result.totalPaymentAmt)
      setFaizOrani(result.faizOrani)
      setYearlyInterestRate(
        isNaN(result.aylikOdeme) ? "% 0" : "% " + result.yearlyInterestRate.toFixed(4)
      )
      setDetails({
        ...details,
        showSlider: true
      })
      dispatch(
        setCalcDetails({
          productDetail: productDetail,
          calcResult: result,
          vade: vade,
          amount: amount,
          showCalcDetails: showCalcDetails
        })
      )
    }
  }, [productDetail, amount, vade, details, showCalcDetails])

  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value

    switch (name) {
      case "identityNumber":
        setIdentityNumber(value)
        setToken("")
        setCaptchaValues({
          ...captchaValues,
          captchaData: "",
          showCaptcha: false
        })
        if (value.length === 11) {
          setIsFetching(true)
          getTokenByTckn1(value)
            .unwrap()
            .then((payload) => {
              if (!payload.IsError) {
                setError('')
                setToken(payload.tokenSessionId)
              } else {
                setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              }
            })
            .finally(() => { setIsFetching(false) })
        }
        break;
      case "captcha":
        setCaptchaValues({
          ...captchaValues,
          captcha: value,
          captchaValidate: true
        })
        break;
      default:
        break;
    }
  }, [getTokenByTckn1, captchaValues])

  const handleAmountChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value.replace(/\./g, "").replace(/[^0-9]+/, ""))
    if (value >= productMinsMaxs.minAmount && value <= productMinsMaxs.maxAmount) {
      setAmount(value)
      setError('')
      setHasAmountError(false)
    } else {
      setError("Kredi Tutarı " + addThousandSeparator(productMinsMaxs.minAmount, false) + " TL - " + addThousandSeparator(productMinsMaxs.maxAmount, false) + " TL arasında olmalıdır.")
      setHasAmountError(true)
      setAylikOdeme(0)
      setTotalPaymentAmt(0)
      setFaizOrani(0)
      setYearlyInterestRate("0")
    }
  }, [amount, vade, productMinsMaxs])

  const handleVadeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value.replace(/\./g, "").replace(/[^0-9]+/, ""))
    if (value >= productMinsMaxs.minVade && value <= productMinsMaxs.maxVade) {
      setVade(value)
      setError('')
      setHasVadeError(false)
    } else {
      setError(addThousandSeparator(amount, false) + " TL için vade aralığı " + productMinsMaxs.minVade + " - " + productMinsMaxs.maxVade + " ay olmalıdır.")
      setHasVadeError(true)
      setAylikOdeme(0)
      setTotalPaymentAmt(0)
      setFaizOrani(0)
      setYearlyInterestRate("0")
    }
  }, [amount, vade, productMinsMaxs])

  const handleSliderChange = useCallback((e?: any, data?: number) => {
    if (data) {
      setVade(data)
    }
  }, [vade])

  const handleChangeShowCalcDetails = () => {
    dispatch(
      setCalcDetails({
        showCalcDetails: showCalcDetails
      })
    )
    setShowCalcDetails(!showCalcDetailsSelector)
    calculatePayment()
  }

  const getProductInfo = useCallback(() => {
    getProductInfoService({
      productType: 4,
      amount: 0,
      term: 0,
      TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setProductDetail(payload.products[0] ? payload.products[0] : [])
          setProductMinsMaxs({
            minVade: payload.products[0]?.minVadeTl ?? minVade ?? 0,
            maxVade: payload.products[0]?.maxVadeTl !== undefined ? Math.floor(payload.products[0]?.maxVadeTl / 30) : maxVade ?? 0,
            minAmount: payload.products[0]?.minTutar ?? minAmount ?? 0,
            maxAmount: payload.products[0]?.maxTutar ?? maxAmount ?? 0
          })
          if (!details.amountChangedByUser && !details.vadeChangedByUser) {
            if (amount && vade) {
              const isAmountValid =
                !isNaN(amount) &&
                amount >= (payload.products[0]?.minTutar ?? minAmount ?? 0) &&
                amount <= (payload.products[0]?.maxTutar ?? maxAmount ?? 0)

              const isVadeValid =
                !isNaN(vade) &&
                vade >= (payload.products[0]?.minVadeTl ?? minVade ?? 0) &&
                vade <= (payload.products[0]?.maxVadeTl !== undefined ? Math.floor(payload.products[0]?.maxVadeTl / 30) : maxVade ?? 0)

              let amountResult = productMinsMaxs.maxAmount,
                vadeResult = productMinsMaxs.maxVade

              if (isAmountValid) {
                amountResult = amount
              }
              if (isVadeValid) {
                vadeResult = vade
              }

              setAmount(amountResult)
              setVade(vadeResult)
              setDetails({
                ...details,
                showSlider: true
              })
            } else {
              setDetails({
                ...details,
                showSlider: true
              })
            }
          }
        }
      })
    setIsCalledProductService(true)
  }, [
    getProductInfoService,
    productMinsMaxs,
    details,
    amount,
    vade
  ])

  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      tckn: identityNumber,
      TokenSessionId: token,
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setError('')
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => { setIsFetching(false) })
  }, [refreshCaptcha, identityNumber, captchaValues, token])

  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (!hasAmountError && !hasVadeError && values && values?.birthdate && values.captcha) {
        setIsFetching(true)
        const parsedBirthDate = getDayMonthYearFromStr(values.birthdate)
        let cid = getCid()
        apply({
          TokenSessionId: token,
          Language: "tr-TR",
          tckn: Number(values.identityNumber),
          birthDate: parsedBirthDate.year + "-" + parsedBirthDate.month + "-" + parsedBirthDate.day,
          phoneCountryCode: "90",
          phoneAreaCode: values.mobilePhone.replace(/\s/g, '').substring(0, 3),
          phoneNumber: values.mobilePhone.replace(/\s/g, '').substr(values.mobilePhone.length - 10),
          kvkk: values.checkboxKvkk,
          amount: amount?.toString(),
          term: vade,
          cid: cid,
          captcha: values.captcha.toUpperCase(),
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError('')
              history.push({
                pathname: "/details/smsotp",
                state: payload
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0,
              });
              refreshCaptcha({
                tckn: identityNumber,
                TokenSessionId: token
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  }
                  else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => { setIsFetching(false) })
            }
          })
          .finally(() => { setIsFetching(false) })
      }
    },
    [history, apply, captchaValues, identityNumber, refreshCaptcha, token]
  )

  return (
    <Page className="calculate-form-page">
      <Form onSubmit={handleSubmit} onChange={handleChange} grid={false}>
        <Panel hasFooter connected={false} className="calculate-form-panel">
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <Grid type="section">
              <Block className="grid-container">
                <Row>
                  <Col xs={24} md={24} lg={3} xl={4} className="row-column">
                    <Element type="h2" className="bapp-panel-body-card-description-landing">
                      Ticari Kredinizi Hesaplayın
                    </Element>
                    <Amount
                      id="amount"
                      name="amount"
                      label="Kredi Tutarı"
                      value={{ amount: amount, currency: "888" }}
                      withDecimalPart={false}
                      withCurrency={false}
                      maxLength={9}
                      allowDecimals={false}
                      allowNegativeValue={false}
                      align={"left"}
                      placeholder={"Lütfen Kredi Tutarı giriniz."}
                      onChange={handleAmountChange}
                      validations={[required("Lütfen kredi tutarı giriniz")]}
                    />
                    <TextField
                      label='Vade'
                      type="number"
                      name="vade"
                      maxLength={4}
                      value={vade.toLocaleString()}
                      validator={RegexpTypes.Numeric}
                      onChange={handleVadeChange}
                      placeholder={"Lütfen Kredi Vadesini giriniz."}
                      className="align-left"
                    />
                    {details.showSlider && (
                      <Block className="bapp-input-container bapp-input align-left">
                        <Slider
                          label="Vade"
                          name="vadeSlider"
                          min={productMinsMaxs.minVade}
                          max={productMinsMaxs.maxVade}
                          className="slider stepMaturity"
                          step={1}
                          defaultValue={vade}
                          valueTitle="Ay"
                          included
                          onChange={handleSliderChange}
                          key={vade}
                        />
                      </Block>
                    )}
                  </Col>
                  <Col xs={24} md={24} lg={6} xl={4} className="row-column middle-col">
                    <Block className="calculate-box">
                      <Image path={"./img/ticarikredi/arrow-bg-left.jpg"} className="bg-left" />
                      <Image path={"./img/ticarikredi/arrow-bg-right.jpg"} className="bg-right" />
                      <Block className="calculate-box-content">
                        <Block className="item item1">
                          <CalcutationAmount
                            delimiterResolver="lang"
                            lang="tr"
                            currency="TL"
                            value={aylikOdeme}
                            integerType="headline3"
                          />
                          <Element type="span" className="detail-span">
                            Aylık Taksit Tutarı
                          </Element>
                        </Block>
                        <Block className="item item2">
                          <Element type="span" className="faiz-orani">
                            % {faizOrani}
                          </Element>
                          <Element type="span" className="detail-span">
                            Faiz Oranı
                          </Element>
                        </Block>
                        <Block className="item item3">
                          <Element type="span" className="label-text">
                            <CalcutationAmount
                              delimiterResolver="lang"
                              lang="tr"
                              currency="TL"
                              value={totalPaymentAmt}
                              integerType="headline3"
                            />
                          </Element>
                          <Element type="span" className="detail-span">
                            Toplam Geri Ödeme Tutarı
                          </Element>
                        </Block>
                        <Link onClick={handleChangeShowCalcDetails} className="link item4">Ödeme Planı</Link>
                      </Block>
                    </Block>
                  </Col>
                  <Col xs={24} md={24} lg={3} xl={4} className="row-column" id="inputArea">
                    <Block className="py-30 px-30 scrollTo">
                      <Element type="h2">
                        {addThousandSeparator(amount, false)} TL için başvuruya başlayın
                      </Element>
                      <TextField
                        label='TC Kimlik No'
                        className="tckn only-number focussedInput"
                        type="number"
                        name="identityNumber"
                        maxLength={11}
                        value={identityNumber}
                        validator={RegexpTypes.Numeric}
                        validations={[required("TC Kimlik Numarası alanı zorunludur."), numeric()]}
                      />
                      <TextField
                        label='Doğum Tarihi'
                        type="text"
                        placeholder="GG.AA.YYYY"
                        mask="99.99.9999"
                        name="birthdate"
                        maxLength={10}
                        validations={[
                          required("Doğum Tarihi alanı zorunludur."),
                          dateFormat("Lütfen Geçerli Bir Tarih Giriniz")
                        ]}
                      />
                      <TextField
                        label='Cep Telefon No'
                        type="text"
                        placeholder="5__ ___ __ __"
                        mask="999 999 99 99"
                        name="mobilePhone"
                        maxLength={13}
                        validations={[
                          required("Cep Telefonu alanı zorunludur."),
                          minLength(13, "Lütfen Geçerli Bir Numara Giriniz")
                        ]}
                      />

                      {captchaValues.showCaptcha && (
                        <Captcha
                          label="Güvenlik Kodu"
                          id="captcha"
                          type="text"
                          name="captcha"
                          placeholder="Güvenlik Kodu"
                          captcha={captchaValues.captchaData}
                          value={captchaValues.captcha}
                          maxLength={4}
                          maxRefreshCount={3}
                          refreshClick={handleCaptchaRefresh}
                          validations={[
                            required("Lütfen güvenlik kodunu giriniz."),
                            minLength(4, "Lütfen güvenlik kodunu giriniz.")
                          ]}
                        />
                      )}
                      <Checkbox
                        name="checkboxKvkk"
                        validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                        className="cb-position-fix"
                        validateOnSubmit={true}
                        block
                      >
                        <Link
                          href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                          text={"Kişisel Verilerin Korunması Kanunu Hakkında Bilgilendirme"}
                          inline
                          target="_blank"
                        />
                        {"’yi okudum"}
                      </Checkbox>
                      <Button text="Hemen Başvur" type="submit" fetching={isFetching} disabled={isFetching}
                        onClick={() =>
                          setCaptchaValues({
                            ...captchaValues,
                            captchaValidate: true
                          })
                        } />
                    </Block>
                  </Col>
                </Row>
              </Block>
            </Grid>
          </Panel.Body>
        </Panel>
      </Form>
    </Page>
  )
}

export default CalculateForm
